import React from "react";
import { motion } from "framer-motion";
import { Globe, MapPin } from "lucide-react";

export default function FeeStructure() {
  return (
    <section id="fees" className="py-16 md:py-24 relative overflow-x-hidden bg-[#0B1429]">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-10 relative">
        <div className="text-center mb-12">
          <div className="text-xs font-semibold text-[#94A3B8] mb-4">Registration Fees</div>
          <h2 className="font-display font-black text-3xl md:text-5xl mb-4">
            Fee <span className="text-[#00F0FF]">Structure</span>
          </h2>
          <p className="text-[#94A3B8] max-w-2xl mx-auto">
            Transparent pricing for both international and Indian participants.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 md:gap-8">
          {/* International Participants */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="card-dark p-8 border border-[#2A3A5F] hover:border-[#00F0FF]/40 transition-colors relative overflow-hidden group"
          >
            <div className="absolute top-0 right-0 p-6 opacity-10 group-hover:opacity-20 transition-opacity">
              <Globe className="w-24 h-24 text-[#00F0FF]" />
            </div>
            <div className="flex items-center gap-3 mb-6 relative z-10">
              <Globe className="w-6 h-6 text-[#00F0FF]" />
              <h3 className="text-xl font-bold text-white">International Participants</h3>
            </div>
            <div className="space-y-4 relative z-10">
              <div className="flex justify-between items-center pb-4 border-b border-white/5">
                <span className="text-[#94A3B8]">Registration Fee</span>
                <span className="text-white font-semibold text-lg">USD 60</span>
              </div>
              <div className="flex justify-between items-center pb-4 border-b border-white/5">
                <span className="text-[#94A3B8]">Event Entry Fee</span>
                <span className="text-white font-semibold text-lg">USD 20 <span className="text-xs text-[#94A3B8] font-normal">/ event</span></span>
              </div>
              <div className="flex justify-between items-center pb-4 border-b border-white/5">
                <span className="text-[#94A3B8]">Relay Event Entry Fee</span>
                <span className="text-white font-semibold text-lg">USD 40 <span className="text-xs text-[#94A3B8] font-normal">/ event</span></span>
              </div>
            </div>
          </motion.div>

          {/* Indian Participants */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.1 }}
            className="card-dark p-8 border border-[#2A3A5F] hover:border-[#00F0FF]/40 transition-colors relative overflow-hidden group"
          >
            <div className="absolute top-0 right-0 p-6 opacity-10 group-hover:opacity-20 transition-opacity">
              <MapPin className="w-24 h-24 text-[#00F0FF]" />
            </div>
            <div className="flex items-center gap-3 mb-6 relative z-10">
              <MapPin className="w-6 h-6 text-[#00F0FF]" />
              <h3 className="text-xl font-bold text-white">Indian Participants (Late Registration)</h3>
            </div>
            <div className="space-y-4 relative z-10">
              <div className="flex justify-between items-center pb-4 border-b border-white/5">
                <span className="text-[#94A3B8]">Registration Fee</span>
                <span className="text-white font-semibold text-lg">₹6,000</span>
              </div>
              <div className="flex justify-between items-center pb-4 border-b border-white/5">
                <span className="text-[#94A3B8]">Event Entry Fee</span>
                <span className="text-white font-semibold text-lg">₹2,000 <span className="text-xs text-[#94A3B8] font-normal">/ event</span></span>
              </div>
              <div className="flex justify-between items-center pb-4 border-b border-white/5">
                <span className="text-[#94A3B8]">Relay Event Entry Fee</span>
                <span className="text-white font-semibold text-lg">₹3,000 <span className="text-xs text-[#94A3B8] font-normal">/ event</span></span>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
